import { render, staticRenderFns } from "./videoindex.vue?vue&type=template&id=2df43687&scoped=true"
import script from "./videoindex.vue?vue&type=script&lang=js"
export * from "./videoindex.vue?vue&type=script&lang=js"
import style0 from "./videoindex.vue?vue&type=style&index=0&id=2df43687&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df43687",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2df43687')) {
      api.createRecord('2df43687', component.options)
    } else {
      api.reload('2df43687', component.options)
    }
    module.hot.accept("./videoindex.vue?vue&type=template&id=2df43687&scoped=true", function () {
      api.rerender('2df43687', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/componentsTeacher/previewVideo/videoindex.vue"
export default component.exports